import axios from 'axios'
import dispatchActionForAllModules from '@utils/dispatch-action-for-all-modules'
import api from '@/api/Api'
import Echo from 'laravel-echo'
import store from '@state/store'
import Auth from '@aetosky/auth'
import config from '@/config'

// window.io = require('socket.io-client')
window.Pusher = require('pusher-js')

export const state = {
  currentUser: undefined,
  currentUserGroup: undefined,
  currentWorkspace: undefined,
  realmUser: undefined
}

export const mutations = {
  UPDATE_TOTAL_TOKEN(state, newValue) {
    state.currentUser.token_amount = newValue
  },
  UPDATE_PLANET_KEY(state, newValue) {
    state.currentUser.planet_key = newValue
  },
  UPDATE_HERE_KEY(state, newValue) {
    state.currentUser.here_key = newValue
  },
  UPDATE_SKYWATCH_KEY(state, newValue) {
    state.currentUser.skywatch_key = newValue
  },
  UPDATE_GOOGLE_KEY(state, newValue) {
    state.currentUser.google_api_key = newValue
  },
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
  },
  SET_CURRENT_WORKSPACE(state, newValue) {
    state.currentWorkspace = newValue
    initEcho(getSavedState('access_token'))
  },
  UPDATE_RATE(state) {
    state.currentUser.rated = true
  },
  SET_CURRENT_USER_GROUP(state, newValue) {
    state.currentUserGroup = newValue
  },
  SET_CURRENT_REALM_USER(state, newValue) {
    state.realmUser = newValue
  }
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
  isAuthorized(state) {
    return state.realmUser?.resource_access?.['aetos-app']?.roles?.includes('app_ai') || false
  },
  userProfile(state) {
    return state.currentUser
  },
  isAdmin(state) {
    if (!state.currentUser) return false
    if (!state.currentUser.id) return false
    return state.currentUser.user_group_id === 3
  },
  currentWorkspaceId(state) {
    return state.currentWorkspace
  },
  currentUserId(state) {
    return state.currentUser ? state.currentUser.id : undefined
  },
  token(state) {
    return getSavedState('access_token')
  },

  currentUserGroup(state) {
    return state.currentUserGroup.map(cug => cug.code)
  }
}

export const actions = {
  async logIn({ commit, dispatch, getters }, token) {
    const auth = Auth.getInstance({
      baseURL: config.auth_server,
      redirectUri: window.location.origin + config.app_path + '/login'
    })

    // Check if the user is logged in. If not, attempt to handle the OAuth2 callback.
    let logged = await auth.isLogged()
    if (!logged) {
      logged = await auth.exchangeCodeForToken()
    }
    // If still not logged in, redirect to the login page.
    if (!logged) {
      await auth.redirectToLogin()
    } else {
      try {
        const res = await api.authSubmit('get', '/me')
        const realmUser = await auth.getUser()
        commit('SET_CURRENT_REALM_USER', realmUser)
        const user = res.data.data
        if (!user.region.code) {
          const regions = await store.dispatch('region/fetchAllRegions')
          store.dispatch('region/setRegion', { region_id: regions[0].id })
        }
        store.commit('region/SET_CURRENT_REGION', user.region.code)
        commit('SET_CURRENT_USER', user)
        return user
      } catch (e) {
        console.log(e)
        return await auth.logout()
      }
    }
  },

  // Logs out the current user.
  async logOut({ commit }) {
    store.commit('region/SET_CURRENT_REGION', undefined)
    commit('SET_CURRENT_USER', undefined)
    commit('SET_CURRENT_REALM_USER', undefined)
    await Auth.getInstance().logout()
  },

  initWorkspaceData({ commit, state, dispatch }, workspaceId) {
    commit('SET_CURRENT_WORKSPACE', workspaceId)
    dispatchActionForAllModules('afterSelectWorkspace')
    return true
  },
  getUser({ state }) {
    return state.currentUser
  }
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return window.localStorage.getItem(key)
}

function initEcho(token) {
  if (token && token.length > 0) {
    // Detemine WebSocket configuration based on protocol
    const wssPort = 443
    const wsPath = '/ws'
    
    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: 'aiapp',
      cluster: '',
      wsHost: config.echo_server,
      wssPort: wssPort,
      wsPath: wsPath,
      enabledTransports: ['ws', 'wss'],
      authEndpoint: config.php_url + '/api/broadcasting/auth',
      auth: {
        headers: {
          Authorization: 'Bearer ' + token
        }
      },
      forceTLS: true,
      disableStats: true
    })
    dispatchActionForAllModules('afterAuthSocket')
  } else {
    window.Echo = undefined
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/auth.js